import Auth from '../Helpers/auth';
import axios from 'axios';
import * as constant from '../global/const';
import { useDispatch } from 'react-redux';
import { setCarritoPromos } from '../Redux/actions/CarritoPromoAction';
import { setCarrito } from '../Redux/actions/CarritoAction';

export const useSucursal = () => {

    const dispatch = useDispatch();
    const dispatchPromo = useDispatch();
    const AgregarCarrito = carrito => dispatch(setCarrito(carrito));
    const AgregarCarritoPromos = carritoPromos => dispatchPromo(setCarritoPromos(carritoPromos));

    let user = JSON.parse(Auth.getUsuario());
    let _carrito = JSON.parse(localStorage.getItem(constant.CARRITO)) || {};
    let _carritoPromos = JSON.parse(localStorage.getItem(constant.CARRITOPROMO)) || {};

    const getValidarCatalogo = async (sucursal) => {
        const cartKeys = Object.keys(_carrito);
        let objects = [];

        //Preparar objetos
        cartKeys.map(
            ck => {
                const aux = _carrito[ck];
                const newElement = {
                    codigoSku: aux.codigoSku,
                    cantidad: aux.cantidad
                }
                objects.push(newElement);
            }
        )

        localStorage.removeItem(constant.CARRITOPROMO);

        await validarCatalogo(sucursal, objects)
            .then(
                response => {
                    if (response.length) {
                        response.map(
                            element => {
                                const aux = cartKeys.find(ck => ck == "-" + element.codigoSku);
                                if (aux && element.agotado == 0) {
                                    validarPromocionRedime(element, sucursal);
                                    validarPrecio(element, _carrito["-" + element.codigoSku].cantidad);
                                } else {
                                    delete _carrito[aux];
                                }

                                AgregarCarrito(_carrito);
                            }
                        )
                    } else {
                        localStorage.removeItem(constant.CARRITO);
                    }
                }
            ).then(
                response => {
                }
            )
        // window.location.reload();
    }

    const validarCatalogo = async (sucursal, productos) => {

        let aux = [];

        await axios.post(
            constant.CAMBIOSUCURSAL + `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&correo=${user.email}`,
            productos
        )
            .then(
                (response) => {
                    aux = response.data;
                }
            ).catch(
                (err) => {
                    console.log("'error' redime -> ", err);
                }
            )

        return aux;
    }
    const validarPromocionRedime = (producto, sucursal) => {
        //Existe el producto en la sucursal y no esta agotado
        const promocion = producto.promocion ? producto.promocion.filter(promo => promo.tipoDescuento == 1) : [];
        const promocionRedime = producto.promocionRedime ? producto.promocionRedime.filter(promoR => promoR.tipoDescuento == 5) : [];

        //Si tiene una promoción, se invalida la promoción que tenga
        if (promocion.length == 0) {
            if (promocionRedime.length > 0) {
                //Se valida las promos
                if (_carrito["-" + producto.codigoSku].cantidad) {
                    validarRedime(producto.codigoSku, promocionRedime[0].numProm, _carrito["-" + producto.codigoSku].cantidad, sucursal, producto.unidadesxCaja)
                        .then(respuesta => {
                                const seleccionados =
                                    respuesta.tipo == 1
                                        ?
                                        [
                                            {
                                                nombre: respuesta.redime[0].nombre,
                                                cantidad: respuesta.cantidadObsequiada,
                                                codigoSkuPromocion: respuesta.redime[0].codigoSku,
                                                unidadesxCaja: respuesta.redime[0].unidadesxCaja,
                                            }
                                        ]
                                        :
                                        []
                                _carritoPromos["-" + producto.codigoSku] = {
                                    codigoSku: producto.codigoSku,
                                    nombre: producto.nombre,
                                    textoDescuentoDetalle: promocionRedime[0].textoDescuentoDetalle,
                                    ...respuesta,
                                    seleccionados: seleccionados,
                                    cantidadReclamada: respuesta.tipo == 1 ? respuesta.cantidadObsequiada : 0,
                                    numProm: promocionRedime[0].numProm
                                }

                                AgregarCarritoPromos(_carritoPromos);
                            }
                        ).catch(
                            error => {
                                console.log("Error en validación - producto promociones redime cambio de sucursal ", error);
                            }
                        )
                }
            }
        }
    }

    const validarPrecio = (producto, cantidad = 0) => {
        const promocion = producto.promocion ? producto.promocion.filter(promo => promo.tipoDescuento == 1) : [];

        //Actulizar datos
        _carrito["-" + producto.codigoSku] = {
            nombre: producto.nombre,
            codigoSku: producto.codigoSku,
            cantidad: cantidad,
            retornable: producto.retornable,
            oferta: producto.oferta,
            iva: parseFloat(producto.ivaPesos),
            ipo: parseFloat(producto.ipo),
            categoria: producto.categoriaId,
            vinetas: producto.vinetas,
            permiteMedia: producto.permiteMedia,
            promocion: producto.promocion,
            promocionRedime: producto.promocionRedime,
            precio: 0,
            precioBase: 0,
        }

        if (promocion.length > 0) {
            //Se actualiza el precios
            _carrito["-" + producto.codigoSku].precio = parseFloat(promocion[0].precio)
            _carrito["-" + producto.codigoSku].precioBase = parseFloat(promocion[0].precioBase)
        } else {
            //Se pone el precio del que ya esta
            _carrito["-" + producto.codigoSku].precio = parseFloat(producto.precio)
            _carrito["-" + producto.codigoSku].precioBase = parseFloat(producto.precioBase)
        }
    }

    const validarRedime = async (codigoSku, numProm, cantidad, sucursal, unidadesxCaja) => {
        let aux = {};
        const redimido = obtenerRedenciones();
        const carrito = obtenerProductos(codigoSku);

        await axios.post(
            constant.GETVALIDACIONREDIME + `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&correo=${user.email}&numprom=${numProm}`,
            {
                codigoSku: codigoSku,
                cantidad: cantidad,
                carrito: carrito,
                redimido: redimido,
                unidadesxCaja: unidadesxCaja
            }
        )
            .then(
                (response) => {
                    if(response?.code == "REDIME_ERROR"){
                        console.log("'error' redime -> ", response.data.mensaje ?? "");
                      } else{
                        aux = response.data;
                      }
                }
            ).catch(
                (err) => {
                    console.log("'error' redime -> ", err);
                }
            )
        return aux;
    }

    const obtenerRedenciones = () => {
        const keys = Object.keys(_carritoPromos);
        let llaves = [];


        if (keys.length > 0) {
            keys.map(
                key => {
                    const newObject = {
                        "numProm": _carritoPromos[key]['numProm'],
                        "cantidadReclamada": _carritoPromos[key]['cantidadReclamada'],
                        "unidadesxCaja": _carritoPromos[key]['unidadesxCaja'],
                    }
                    llaves.push(newObject);
                }
            )
        }

        return llaves;
    }
    const obtenerProductos = (codigoSku) => {
        const keys = Object.keys(_carrito);
        let productos = [];


        if (keys.length > 0) {
            keys.map(
                key => {
                    if (key.replace("-", "") != codigoSku) {
                        const newObject = {
                            "codigoSku": _carrito[key]['codigoSku'],
                            "cantidad": _carrito[key]['cantidad'],
                            "presentacionId": _carrito[key]['presentacionId'],
                            "unidadesxCaja": _carrito[key]['unidadesxCaja']
                        }
                        productos.push(newObject);
                    }
                }
            )
        }

        return productos;
    }

    return { getValidarCatalogo }
}
